export default __webpack_public_path__ + "static/media/socket.io.f3295f36.svg";